import {
  Welcome,
  Stats,
  RecentEnquiries,
  RecentFavorites,
} from "./components";

export default function BuyerDashboardPage() {
  return (
    <div className="min-h-screen bg-gray-50/50">
      <div className="px-4 sm:px-6 lg:px-8 max-w-[1600px] mx-auto py-5 space-y-5">
        <Welcome />

        <section className="space-y-3">
          <h2 className="text-xs font-semibold uppercase tracking-wider text-gray-500">
            Overview
          </h2>
          <Stats />
        </section>

        <section className="grid grid-cols-1 xl:grid-cols-2 gap-5">
          <RecentEnquiries />
          <RecentFavorites />
        </section>
      </div>
    </div>
  );
}
